import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators'; // <--- New Imports
import * as _ from 'lodash';

import { PONodeComponent } from '../../components/po-treeview/abstract-classes/po-node/ponode.component';
import { ProductOverviewService } from '../product-overview/product-overview.service';
import { ClusterNodeComponent } from '../../components/po-treeview/cluster-node/cluster-node.component';

@Injectable({
  providedIn: 'root',
})
export class AggregateArrangementsService {
  private error: any;
  private sumOfAmountMatchList: any[] = [];

  productNodeNameRestrictedDataViewExceptionMap = new Map();

  constructor(private productOverviewService: ProductOverviewService) {
  }

  generateSumOfAmountKeysAndGetSumOfAmounts(response: any): Observable<any> {
    const sumOfAmountKeys: any[] = [];

    this.recursiveListSearch(response.children, null, null).forEach((sumOfAmountKey) => {
      sumOfAmountKeys.push(sumOfAmountKey);
    });

    return this.productOverviewService.getSumOfAmounts(sumOfAmountKeys, this.productNodeNameRestrictedDataViewExceptionMap)
      .pipe(
        map((res) => {
          return res;
        }),
        tap({
          error: (error) => {
            this.error = error;
          }
        })
      );
  }

  private recursiveListSearch(hierarchyNodes: any[], parentName: string | null, restrictedDataViewException: boolean | null): any[] {
    const keys: any[] = [];

    if (parentName) {
      this.productNodeNameRestrictedDataViewExceptionMap.set(parentName, restrictedDataViewException);
    }

    if (hierarchyNodes) {
      hierarchyNodes.forEach((hierarchyNode) => {
        if (hierarchyNode['type'] === 'ARRANGEMENT_TYPE') {
          const key: any = {
            administrationCode: hierarchyNode.data.administrationCode,
            arrangementNumber: hierarchyNode.data.arrangementNumber,
            productNodeName: parentName,
          };
          keys.push(key);
        } else {
          const childrenKeys = this.recursiveListSearch(
            hierarchyNode.children,
            hierarchyNode.data.product,
            hierarchyNode.data.restrictedDataViewException
          );

          childrenKeys.forEach((node) => {
            keys.push(node);
          });
        }
      });
    }
    return keys;
  }

  addAmountsToMatchingProductNode(response: any, amountSums: any[]) {
    this.sumOfAmountMatchList = amountSums;

    if (response.children) {
      response.children.forEach((clusterNode: any) => {
        this.recursivelySearchForProductNode(clusterNode, amountSums);
      });

      response.children.forEach((clusterNode: ClusterNodeComponent) => {
        this.createSumOfChildren(clusterNode);
      });
    }
    return response;
  }

  private recursivelySearchForProductNode(node: PONodeComponent, amountSums: any[]) {
    let amountAdded = false;
    if (amountSums) {
      amountSums.forEach((amountSum) => {
        if ((node.data.product === amountSum['productNodeName'] && node.nodeType === 'product-node')) {
          this.addAmountToProductNode(node, amountSum);
          amountAdded = true;
        }
      });
    }

    if (!amountAdded && node.children) {
      node.children.forEach((childNode) => {
        this.recursivelySearchForProductNode(childNode, amountSums);
      });
    }
  }

  private createSumOfChildren(node: PONodeComponent): number {
    let sum = 0;
    const index = _.findIndex(this.sumOfAmountMatchList, { productNodeName: node.data.product });

    if (node.children) {
      node.children.forEach((childNode) => {
        if (childNode.data.restrictedData) {
          sum += (typeof childNode.data.totalAmount === 'number' ? childNode.data.totalAmount : 0);
        } else {
          if (childNode.data.totalAmount) {
            if (childNode.data.totalAmountSuffix) {
              node.data.totalAmountSuffix = childNode.data.totalAmountSuffix;
            }
            sum += childNode.data.totalAmount;
          } else if (childNode.children && childNode.children.length) {
            sum += this.createSumOfChildren(childNode);
          }

          if (sum === 0 && index > -1) {
            sum += this.sumOfAmountMatchList[index].sumOfAmounts;
          }
        }
      });
    }

    this.addAmountToParentNode(node, sum);
    return sum;
  }

  private addAmountToProductNode(productNode: PONodeComponent, amountSum: any) {
    if (amountSum['sumOfAmounts']) {
      productNode.data.totalAmount = amountSum['sumOfAmounts'];
      productNode.data.totalAmountSuffix = amountSum['totalAmountSuffix'];
    } else {
      productNode.data.restrictedData = true;
      productNode.data.totalAmount = amountSum['shielded'];
    }
  }

  private addAmountToParentNode(node: PONodeComponent, sum: any) {
    if (typeof sum === 'number') {
      node.data.totalAmount = Number((sum).toFixed(2));
    } else if (sum === 'Afgeschermd') {
      node.data.restrictedData = true;
      node.data.totalAmount = sum;
    }
  }
}
